// extracted by mini-css-extract-plugin
export var adjacentSlide = "_oi-9";
export var arrowButtonContainer = "_oi-5";
export var arrowButtonIcon = "_oi-6";
export var carouselArrowButton = "_oi-2";
export var carouselElementContainer = "_oi-1";
export var currentSlide = "_oi-8";
export var left = "_oi-3";
export var otherSlide = "_oi-a";
export var productCarouselContainer = "_oi-0";
export var right = "_oi-4";
export var sliderOverflow = "_oi-7";